import redirectToLogin from '../../apps/auth/redirect-to-login';

const state = {
  isSuperuser: false,
  username: '',
};

const mutations = {
  SET_SUPERUSER(state, value) {
    state.isSuperuser = value;
  },
  SET_USERNAME(state, value) {
    state.username = value;
  },
};

const actions = {
  async fetchUserInfo({ commit }) {
    try {
      const res = await fetch('/api/v1/current-user/', {
        credentials: 'same-origin'
      });

      if (res.ok) {
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const data = await res.json();
          commit('SET_SUPERUSER', data.is_superuser);
          commit('SET_USERNAME', data.username);
          return;
        }
        // 200 с не-JSON (редирект на логин был выполнен браузером) — сессия недействительна
        redirectToLogin();
        return;
      }

      // 401/403 — сессия истекла или нет доступа
      if (res.status === 401 || res.status === 403) {
        redirectToLogin();
        return;
      }

      commit('SET_SUPERUSER', false);
      commit('SET_USERNAME', '');
    } catch (error) {
      console.error('Ошибка получения информации о пользователе:', error);
      commit('SET_SUPERUSER', false);
      commit('SET_USERNAME', '');
    }
  },
};

const getters = {
  isSuperuser: state => state.isSuperuser,
  username: state => state.username,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}; 